import React from "react";
import { View } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import Skeletons from "../skeleton-components/Skeletons";

const RankingTableSkeleton: React.FC = () => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();

  return (
    <View style={{}}>
      {/* Search Input */}
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          gap: 10,
        }}
      >
        <Skeletons
          width={"344px"}
          height={31}
          style={{
            borderRadius: 4,
            backgroundColor: AppColors.appBlackColor_1e1e1e,
          }}
        />
      </View>

      {/* BeltRanking Placeholder */}
      <View
        style={[
          {
            marginTop: 10,
            justifyContent: "space-between",
            gap: 10,
          },
          styles.deviceflexDirection,
        ]}
      >
        <View style={[styles.beltsRankingView, { flex: 1 }]}>
          {Array(5)
            .fill(null)
            .map((_, index) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 10,
                  borderRadius: 4,
                  backgroundColor: AppColors.black_191919,
                  marginBottom: 8,
                }}
              >
                <Skeletons
                  width={"40px"}
                  height={20}
                  style={{ borderRadius: 4 }}
                />
                <Skeletons
                  width={"100px"}
                  height={20}
                  style={{ borderRadius: 4 }}
                />
                <Skeletons
                  width={"60px"}
                  height={20}
                  style={{ borderRadius: 4 }}
                />
              </View>
            ))}
        </View>
      </View>
    </View>
  );
};

export default RankingTableSkeleton;

const useStyles = CreateResponsiveStyle(
  {
    deviceflexDirection: {
      flexDirection: "row",
    },
    beltsRankingView: {
      width: "100%",
      borderRadius: 10,
      paddingBottom: 15,
      gap: 10,
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {
      deviceflexDirection: {
        flexDirection: "column",
      },
    },
    [DEVICE_SIZES.XS]: {
      deviceflexDirection: {
        flexDirection: "column",
      },
    },
  }
);
